'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg12FilledChalkAlpha05 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 21, height: 20, viewBox: "0 0 21 20", fill: "none" }, props),
    React__namespace.createElement("circle", { cx: 10.9953, cy: 10, r: 9, fill: "rgba(255, 255, 255, 0.05)" }),
    React__namespace.createElement("g", { clipPath: "url(#12FilledChalkAlpha05_svg__clip0_35349_57607)" },
        React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.4821 5.21301C7.13063 4.86154 6.56078 4.86153 6.20931 5.213C5.85783 5.56446 5.85782 6.13431 6.20929 6.48579L9.7231 9.99969L6.20949 13.5134C5.85803 13.8649 5.85803 14.4347 6.20951 14.7862C6.56099 15.1376 7.13084 15.1376 7.4823 14.7862L10.9959 11.2725L14.5094 14.7862C14.8609 15.1376 15.4308 15.1376 15.7822 14.7862C16.1337 14.4347 16.1337 13.8649 15.7823 13.5134L12.2687 9.99969L15.7825 6.48579C16.1339 6.13431 16.1339 5.56446 15.7824 5.213C15.431 4.86153 14.8611 4.86154 14.5097 5.21301L10.9959 8.72688L7.4821 5.21301Z", fill: "white" })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "12FilledChalkAlpha05_svg__clip0_35349_57607" },
            React__namespace.createElement("rect", { width: 12, height: 12, fill: "white", transform: "translate(4.99533 4)" })))));

exports.default = Svg12FilledChalkAlpha05;
//# sourceMappingURL=12FilledChalkAlpha05.js.map
